<template>
  <div id="SeminarForm">
    <GoogleFormWrapper :formSrc="formSrc" />
  </div>
</template>

<script>
import GoogleFormWrapper from 'views/components/GoogleFormWrap'

export default {
  components: { GoogleFormWrapper },
  data() {
    return {
      formSrc: 'https://docs.google.com/forms/d/e/1FAIpQLScLd2eRHckwZxNYbXFwVDhmQ_NGqaeB33y3QSDANfklaHaybQ/viewform?embedded=true',
    }
  },
}
</script>

<style lang="scss">
#SeminarForm {
  background-color: $white;
  height: 100vh;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;

  .GoogleFormWrapper {
    height: 100vh;
    @include md {
      height: 65vh;
    }

    iframe {
      border: none;
      height: 90vh;
      width: 100%;
      @include md {
        max-height: 435px;
      }
    }
  }
}
</style>
